<!-- associated users links -->
<section>
  <h1>{{titleText+'.title'|translate}}</h1>
  <form *ngIf="!isLoading; else spinner" [formGroup]="form" class="wrap">

    <div class="form-group row">
      <div class="form-group row">
        <app-input [label]="'input.user'" [formControl]="f('referent')" [autocompletionType]="'users'"
          [autocompletionQP]="USER_ROLES_ALLOWED" [size]="12" [hasDeleteBtn]="f('referent').value?.uid"
          [isDisabled]="f('referent').value?.uid" (clickedOption)="onAddUser($event)"
          (clickedDelete)="onDeleteUser()"></app-input>
      </div>
    </div>
  </form>
</section>

<ng-template #spinner>
  <p class="wrap-spinner">
    <mat-spinner [diameter]="20"></mat-spinner>
  </p>
</ng-template>